import { useState } from 'react';
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import MDTypography from 'components/MDTypography';
import { Modal, Box } from '@mui/material';
import { verifyDeposits } from 'services/finance.service';
import { toast } from 'react-toastify';

const VerifyBankModal = (props) => {
  const { id, fetchPropertyTypeBankDetails, setModalOpen, modalOpen } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState({
    firstAmount: '',
    secondAmount: '',
  });
  //handler function
  const handleAmountInput = (e) => {
    const { name, value } = e.target;
    setAmount((state) => {
      return {
        ...state,
        [name]: value ? Number(value) : '',
      };
    });
  };
  const handleVerifyDeposit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await verifyDeposits(id, amount);
      if (!res.isError) {
        fetchPropertyTypeBankDetails();
        toast.success(res?.message);
        setModalOpen(false);
        setAmount({ firstAmount: '', secondAmount: '' });
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setIsLoading(false);
  };
  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 3,
          }}
        >
          <MDTypography id="modal-modal-title" variant="h4" component="h2">
            Verify Bank Account
          </MDTypography>
          <MDBox mt={3} display="flex" flexDirection="column" gap="16px">
            <MDInput
              name="firstAmount"
              value={amount.firstAmount}
              type="number"
              label="Amount 1"
              fullWidth
              onChange={handleAmountInput}
            />
            <MDInput
              name="secondAmount"
              value={amount.secondAmount}
              type="number"
              label="Amount 2"
              fullWidth
              onChange={handleAmountInput}
            />
          </MDBox>
          <MDBox align="right" marginTop="32px">
            <MDButton
              onClick={() => {
                setModalOpen(false);
                setAmount({ firstAmount: '', secondAmount: '' });
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              color="info"
              onClick={handleVerifyDeposit}
              isLoading={isLoading}
              disabled={
                !(amount.firstAmount && amount.secondAmount) || isLoading
              }
            >
              Submit
            </MDButton>
          </MDBox>
        </Box>
      </Modal>
    </>
  );
};

export default VerifyBankModal;
